// hooks/useToast.js
import { useState, useCallback } from 'react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((toast) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      isVisible: true,
      duration: 5000,
      ...toast
    };

    setToasts(prev => [...prev, newToast]);

    // Auto remove after duration + animation time
    setTimeout(() => {
      removeToast(id);
    }, newToast.duration + 300);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  // Convenience methods
  const success = useCallback((title, message, options = {}) => {
    return showToast({
      type: 'success',
      title,
      message,
      ...options
    });
  }, [showToast]);

  const error = useCallback((title, message, options = {}) => {
    return showToast({
      type: 'error',
      title,
      message,
      duration: 7000, // Errors stay longer
      ...options
    });
  }, [showToast]);

  const warning = useCallback((title, message, options = {}) => {
    return showToast({
      type: 'warning',
      title,
      message,
      ...options
    });
  }, [showToast]);

  const info = useCallback((title, message, options = {}) => {
    return showToast({
      type: 'info',
      title,
      message,
      ...options
    });
  }, [showToast]);

  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    warning,
    info
  };
};

export default useToast;